<template>
  <generic-modal :modal-key="'failed_purchase_operator'" :has-extra-modal-class="'store_popup_box purchase purchase_failed modal_cont'"
                 @close="$emit('close')">
    <template slot="content">
        <h1>{{ getTranslations.home_modals_failed_purchase_operator_purchase_failed }}</h1>
        <img src="static/images/store/photo-fail.png" class="op_down_img">
        <p>{{ getTranslations.home_modals_failed_purchase_operator_purchase_not_successful }}</p>
    </template>
  </generic-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import GenericModal from '../../sharedcomponents/GenericModal';

export default {
  name: 'failedPurchaseOperator',
  components: { GenericModal },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/store/FailedPurchaseOperator.vue